module.exports = __webpack_public_path__ + "static/media/squash_530_gr.a213ab54.png";